import ramiroPic from "@/public/images/artists/ramiro.jpg";
import { Artist } from "@/types/types";

export const ramiro = {
  id: "230",
  name: "Ramiro",
  image: ramiroPic,
  description: `Ramiro's voice has a distinctive timbre, characterized by a deep but slightly nasal tone. His vocal delivery is laid-back, with a unique mix of smooth melodic lines and quick, almost percussive phrasing, making it stand out in reggaeton and Latin trap.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Framiro-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Latin", "Pop", "Dance", "Unprocessed", "Ballads", "Hip Hop"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 45,
        high: 70,
      },
      sweetSpot: 60,
    },
  },
} as const satisfies Artist;
